/**
 * Medición de los módulos de la landing (ADR 150 + 153).
 *
 * Un solo listener delegado en el documento en vez de uno por tarjeta: los
 * módulos se pintan por bloques configurables y su número cambia desde el theme
 * editor, así que enganchar uno por uno obligaría a re-enganchar cada vez.
 *
 * `data-vault-modulo` dice de qué sección salió el clic y `data-vault-destino`
 * a dónde iba. Con eso se responde la pregunta que la iniciativa del menú
 * declaró y nunca pudo medir: cuánta gente cruza del storefront a la app.
 */
// Tres secciones piden este archivo (herramientas, juegos y pulso) y el navegador
// ejecuta una vez por cada etiqueta `<script>`: sin este candado había tres
// listeners y un solo clic mandaba el evento tres veces, inflando la métrica.
if (window.vaultModulosListo) {
  console.debug('vault-modulos ya estaba enganchado');
} else {
  window.vaultModulosListo = true;

  document.addEventListener('click', function (evento) {
    var elemento = evento.target.closest('[data-vault-modulo]');
    if (!elemento || !window.vaultEvento) return;

    window.vaultEvento(
      'landing_modulo_click',
      elemento.dataset.vaultModulo + ':' + (elemento.dataset.vaultDestino || '')
    );
  });
}
